import React, { ReactNode, useEffect, useState } from 'react'
import './inputs.sass'
import UppercaseLabel from '../Typography/UppercaseLabel'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    onValueChange: (newVal: string) => void
    valuePostfix: ReactNode
    inputLabel?: string
    validationCondition?: RegExp
    onInputError?: (isError: boolean) => void
}

const FixedMeasureInput: React.FC<Props> = ({
    valuePostfix,
    onValueChange,
    inputLabel,
    validationCondition,
    onInputError,
    ...props
}) => {
    const [inputValue, setInputValue] = useState('')
    const [isErrorStatus, setIsErrorStatus] = useState(false)

    useEffect(() => {
        if (!validationCondition) return
        const timer = setTimeout(() => {
            if (!inputValue) setIsErrorStatus(false)
            else {
                const errorStat = !validationCondition?.test(inputValue)
                setIsErrorStatus(errorStat)
                if (onInputError) onInputError(errorStat)
            }
        }, 500)

        return () => clearTimeout(timer)
    }, [inputValue])

    return (
        <div className="text-input-wrapper">
            {inputLabel && (
                <div className="text-input-wrapper__label-container">
                    <UppercaseLabel>{inputLabel}</UppercaseLabel>
                </div>
            )}
            <div className={`text-input-component fixed-measure-input-component ${isErrorStatus ? 'input-error' : ''}`}>
                <input
                    className="text-input-component__input-element reset-appearance"
                    type={props.type}
                    value={props.value}
                    onChange={(e) => {
                        setInputValue(e.target.value)
                        onValueChange(e.target.value)
                    }}
                    {...props}
                />
                {valuePostfix && (
                    <>
                        <div className="fixed-measure-input-component__vertical-separator" />
                        <div className="fixed-measure-input-component__value-postfix center-box">{valuePostfix}</div>
                    </>
                )}
            </div>
        </div>
    )
}

export default FixedMeasureInput
